import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import logoEvol from 'assets/images/logo_evol.png';
import Image from 'components/atoms/Image';
import Container from 'components/organisms/Container';
import mapModifiers from 'utils/functions';

const HeaderCheckout: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [fixed, setFixed] = useState(false);
  const sidebarRef = useRef<HTMLDivElement>(null);
  const navigation = useNavigate();

  const closeSidebar = () => {
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        open
        && sidebarRef.current
        && !sidebarRef.current.contains(event.target as Node)
      ) {
        closeSidebar();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setFixed(true);
      } else {
        setFixed(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header
      className={`${mapModifiers('o-headerCheckout', fixed && 'fixed')}`}
    >
      <Container fullWidth>
        <div className="o-headerCheckout_wrapper">
          <div onClick={() => navigation('/')} className="o-headerCheckout_logo">
            <Image
              ratio="205x42"
              src={logoEvol}
              alt="Logo Evol"
              size="contain"
              className="t-login_logo"
            />
          </div>
        </div>
      </Container>
    </header>

  );
};

export default HeaderCheckout;
